import React, { useEffect, useState } from 'react'
import { loadFacebookSDK } from '../../lib/facebook-sdk'
import useGetSocialAppId from '@/services/api/auth/useGetSocialAppId'
import facebook from '@/assets/svg/facebook.svg'
import { Button, ButtonText } from '@/components/ui/button'
import useLogin from '@/services/api/auth/useLogin'

export default function FacebookLoginButton({
  isLoading,
  setIsLoading,
  onSuccess,
}: {
  isLoading: boolean
  setIsLoading: (isLoading: boolean) => void
  onSuccess: () => void
}) {
  const { login, loginStatus } = useLogin()
  const [sdkLoaded, setSdkLoaded] = useState(false)
  const { data: fbData, isLoading: isLoadingFb } = useGetSocialAppId({
    platform: 'facebook',
  })
  const appId = fbData?.platform_id

  useEffect(() => {
    if (appId) {
      loadFacebookSDK(appId).then(() => {
        setSdkLoaded(true)
      })
    }
  }, [appId])

  const handleFacebookLogin = (e) => {
    if (!window.FB) return
    setIsLoading(true)

    window.FB.login(
      (response) => {
        if (response?.status === 'connected' && response?.authResponse) {
          const { accessToken } = response.authResponse

          login({ platform: 'facebook', accessToken })
            .then(() => {
              onSuccess()
            })
            .finally(() => {
              setIsLoading(false)
            })
        } else {
          console.error('Facebook login failed')
          setIsLoading(false)
        }
      },
      { scope: 'public_profile,email' },
    )
  }

  return (
    <Button
      onClick={handleFacebookLogin}
      disabled={!sdkLoaded}
      variant="outline"
      size="lg"
      className="w-full"
      loading={isLoading}
    >
      <img src={facebook} alt="Facebook" />
      <ButtonText>Continue with Facebook</ButtonText>
    </Button>
    // <button onClick={handleFacebookLogin} disabled={!sdkLoaded}>
    //   Login with Facebook
    // </button>
  )
}
